import { getWorkerShiftHistory } from "@/queries/api/businessShiftApi";
import { getWorkerProfileForEmployer } from "@/queries/api/profileApi";
import { getWorkerReviews } from "@/queries/api/reviewApi";
import { QueryKeys } from "@/queries/queryKeys";

export function makeProfileQuery(workerId: string | undefined) {
  return {
    queryKey: [QueryKeys.PUBLIC_USER_PROFILE, workerId],
    queryFn: () => getWorkerProfileForEmployer(workerId as string),
  };
}

export function makeReviewQuery(workerId: string | undefined) {
  return {
    queryKey: [QueryKeys.WORKER_REVIEWS, workerId],
    queryFn: () => getWorkerReviews(workerId as string),
  };
}

export function makeWorkerShiftHistoryQuery(workerId: string | undefined) {
  return {
    queryKey: [QueryKeys.WORKER_SHIFT_HISTORY, workerId],
    queryFn: () => getWorkerShiftHistory(workerId as string),
    enabled: !!workerId,
  };
}
